import { FilterValueModel, LabelValueModel, SearchInputModel } from "./document-type-document-response";
import { DocumentTypeMetadataOptionResponseModel } from "./document-type-metadata-option-response";

export class DocumentResponseModel {
    documentCabinetId: number;
    docuwareCabinetId: string;
    documentCabinetName: string;
    IsActive: boolean;
    documentCountForSearchModule: number;
}

export class DocumentTypesModel {
    DocumentCabinetId: number;
    DocumentTypeId: number;
    DocumentCabinetName: string;
    DocumentTypeName: string;
    DocumentTypeURL: string;

    // Permissions  
    isFull: boolean;
    isView: boolean;
    isCreate: boolean;
    isEdit: boolean;
    isDelete: boolean;
}

export class SearchRawDataForDynamicObjectModel {
    BackupSearchRecords: any[];
    // SearchInput: SearchInputModel[];
    SearchInput: SearchInputModel[];
}

export class SearchInputModelForDynamicObj {
    DocumentTypeMetadataId: number;
    DisplayAs: string;
    FieldName: string;
    FieldType: string;
    Sequence: number;
    IsSearch?: boolean;
    IsRequired?: boolean;
    IsDisplay?: boolean;
    FilteredValues: LabelValueModel[];
    Values: LabelValueModel[];
}

export class SearchDocumentTypeModel {
    DocumentCabinetId: number;
    DocuwareCabinetId: number;
    DocumentTypeId: number;
    DocumentCabinetName: string;
    DocumentTypeName: string;
    DocumentTypeURL: string;
    DocumentTypeMetadatas: Array<SearchDocumentTypeMetadataModel>;
    DocumentTypeMetadataOptions: Array<SearchDocumentTypeMetadataModel>;
    DocumentTypeInboxes: Array<SearchDocumentTypeInbox>;
    DocumentTypeDocumentMetadatas: Array<SearchDocumentTypeMetadataOptionModel>;
}

export class SearchDocumentTypeInbox {
    DocumentTypeInboxId: number;
    DocumentTypeId: number;
    DocumentPath: string;
    FileSize: string;
    IsMapped: boolean;
    IsPublic: boolean;
    ActualDocumentName: string;
}

export class SearchDocumentTypeDocumentMetadataModel {
    DocumentTypeDocumentMetadataId: number;
    DocumentTypeInboxId: number;
    DocumentTypeMetadataId: number;
    MetadataValue: string;
}

export class SearchDocumentTypeMetadataModel {
    DocumentTypeMetadataId: number;
    DocumentTypeId: number;
    FieldName: string;
    DisplayName: string;
    FieldType: string;
    DecimalPlaces: number;
    DefaultValue: string;
    IsRequired: boolean;
    IsSearch: boolean;
    IsDisplay: boolean;
    IsDeleted: boolean;
    SearchSequence: number;
    DisplaySequence: number;
}

export class SearchDocumentTypeMetadataOptionModel {
    DocumentTypeMetadataOptionId: number;
    DocumentTypeMetadataId: number;
    DocumentTypeMetafieldsOptionValue: string;
    IsDefaultSelected: boolean;
}

export class DocumentCabinetsForSearchMetadataModel {
    DocumentTypeId: number;
    DocumentCabinetId: number;
    DocumentCabinetName: string;
    DocumentTypeName: string;
    DocumentTypeMetadatas: Array<SearchDocumentTypeMetadataModel>;
    DocumentTypeMetadataOptions: Array<SearchDocumentTypeMetadataOptionModel>;
}

export class DocumentTypesForSearchMetadataModel {
    DocumentTypeId: number;
    DocumentTypeName: string;
    DocumentTypeMetadatas: Array<SearchDocumentTypeMetadataModel>;
    DocumentTypeMetadataOptions: Array<SearchDocumentTypeMetadataOptionModel>;
    DocumentTypeDocumentMetadatas: Array<SearchDocumentTypeMetadataOptionModel>;
}

export class DynamicDocumentTypeInbox {
    DocumentTypeInboxId: number;
    IsPublic?: boolean;
    DynamicFields: { [key: string]: any };
}


export class SearchMetadataRequestModel {
    DocumentTypeId: number;
    forCustomPage: boolean;
    IsAdvanceSearch?: boolean;
    MatchType?: string;
    IsPublic?: string;
    OCRStatus?: string;
    PageNumber: number;
    PageSize: number;
    SortColumn: string;
    SortOrder: string;
    SortColumnFieldType: string;
    MetadataSearch: Array<SearchMetadataModel>;
}

export class SearchMetadataModel {
    DocumentTypeMetadataId: number;
    FieldName: string;
    FieldType: string;
    FieldValueFrom: string;
    FieldValueTo: string;
    FieldCondition?: LabelValueModel[];
}

export class DocumentTypeMetadataModel {
    DocumentTypeMetadataId: number;
    DocumentTypeId: number;
    FieldName: string;
    DisplayName: string;
    FieldType: string;
    DecimalPlaces: number;
    DefaultValue: string;
    IsRequired: boolean;
    IsSearch: boolean;
    IsDisplay: boolean;
    IsDeleted: boolean;
    SearchSequence: number;
    DisplaySequence: number;
    isNewlyAdded: boolean;
    decimalPipe: string;
    LastModifiedBy: number;
    DocumentTypeMetadataOptions: Array<SearchDocumentTypeMetadataOptionModel>;
}

export class DocumentTypeModel {
    DocumentTypeId: number;
    DocumentCabinetId: number;
    DocuwareCabinetId: number;
    DocumentCabinetName: string;
    DocumentTypeName: string;
    IsVisibleToCustomer: boolean;
    DocumentTypeMetadatas: Array<DocumentTypeMetadataModel>;
}

export class DocumentCabinetModel{
    CompanyId: number;
    DocumentCabinetId: number;
    DocuwareCabinetId: string;
    DocumentCabinetName: string;
    IsActive: boolean;
    DocumentTypes: Array<DocumentTypeModel>
}

export class GetDocumentInboxRecords{
    DocumentTypeInboxId: number;
    DocumentTypeId: number;
    DocumentPath: string;
    FileSize: string;
    IsMapped: boolean;
    IsPublic: boolean;
    ActualDocumentName: string;
    DocumentTypeDocumentMetadata: Array<GetDocumentTypeDocument>;
}

export class GetDocumentTypeDocument{
    DocumentTypeDocumentMetadataId: number;
    DocumentTypeInboxId: number;
    DocumentTypeMetadataId: number;
    MetadataValue: string;
    DocumentTypeMetadata: Array<DocumentTypeMetadataModel>;
}

export class GetDocumentTypeModel {
    DocumentTypeId: number;
    DocumentCabinetId: number;
    DocuwareCabinetId: number;
    DocumentCabinetName: string;
    DocumentTypeName: string;
    IsVisibleToCustomer: boolean;
    AreDocumentsPublic: boolean;
    DocumentTypeMetadatas: Array<DocumentTypeMetadataModel>;
}

export class SearchCondition {
    selectedField?: any;
    selectedCondition?: LabelValueModel[];
    enteredValue?: any;
    enteredValueTo?: any;
    conditionOptions?: { label: string, value: string }[];
    values?: FilterValueModel[];
}
